import joi from 'joi';

export interface Visit {
  profileId: string;
  programId: string;
  date: string;
  timezone?: string;
}

export const visitPayloadSchema = joi.object<Visit>({
  profileId: joi.string(),
  programId: joi.string(),
  date: joi.string().isoDate(),
  timezone: joi.string().optional().empty('').allow(null).default('Europe/Brussels'),
});
